import React from 'react';
import './SoftwareDevelopmentOffer.css';
import a from './1.png';
import b from './2.png';
import c from './3.png';

const fitItems = [
    'עסקים שצריכים מערכת שמותאמת באמת לתהליך העסקי שלהם.',
    'חברות עם מערכת קיימת שכבר לא מספיקה לצמיחה או לשינויים.',
    'סטארטאפים וחברות שרוצים לפתח מוצר SaaS על בסיס נכון.',
    'ארגונים שצריכים חיבור נכון בין מערכות, תהליכים ואנשים.'
];

const problemItems = [
    'המערכת הקיימת מגבילה את הצמיחה במקום לתמוך בה.',
    'תהליכים עדיין מתבצעים ידנית וגוזלים זמן יקר.',
    'כל שינוי קטן במערכת לוקח יותר מדי זמן או יוצר סיכון.',
    'יש תלות גבוהה במפתח אחד או בספק אחד.',
    'אין חיבור נכון בין מערכות קיימות.',
    'נבנה משהו מהר כדי להתקדם, ועכשיו צריך לייצב ולסדר.',
    'יש יותר מדי פתרונות זמניים במקום מערכת אחת נכונה.',
    'קשה להוסיף פיצ׳רים בלי לפגוע ביציבות.'
];

const audienceSignals = [
    'אם אתם צריכים מערכת שמותאמת באמת לדרך שבה העסק שלכם עובד.',
    'אם כבר יש לכם מערכת, אבל היא לא תומכת בצמיחה.',
    'אם התחלתם לפתח מהר ועכשיו צריך לייצב, לסדר ולהמשיך נכון.',
    'אם אתם צריכים שותף פיתוח שמבין גם מבנה מערכת, אינטגרציות וחשיבה לטווח ארוך.'
];

const processSteps = [
    {
        number: '01',
        title: 'שיחת היכרות והבנת הצורך',
        text: 'מבהירים מה צריך לבנות, מה העסק מנסה לפתור, ואיפה נמצאים החסמים.'
    },
    {
        number: '02',
        title: 'ניתוח המערכת, הרעיון או התהליך',
        text: 'בודקים את המצב הקיים, הדרישות, התלויות והסיכונים לפני שמתחילים לפתח.'
    },
    {
        number: '03',
        title: 'בניית כיוון ברור לפיתוח',
        text: 'מגדירים מבנה, סדרי עדיפויות ותוכנית עבודה שאפשר באמת להתקדם איתה.'
    },
    {
        number: '04',
        title: 'ליווי בביצוע ובהמשך',
        text: 'ממשיכים לבנות, לייצב ולשפר בצורה שמאפשרת תחזוקה וצמיחה לאורך זמן.'
    }
];

const trustPoints = [
    'ניסיון בפיתוח, תשתיות וענן.',
    'הסתכלות עסקית ולא רק טכנית.',
    'חשיבה על יציבות, תחזוקה וצמיחה כבר מההתחלה.',
    'גישה פרקטית שמחברת בין רעיון, מערכת וביצוע.'
];

const bookingUrl = 'https://meetings.hubspot.com/viacheslav-seifer';

const SoftwareDevelopmentOffer = () => {
    const scrollToForm = () => {
        const formElement = document.getElementById('epic-development-form');
        if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <section className="software-development-offer">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 text-center">
                        <h2 className="offer-title">פיתוח תוכנה לעסקים שצריכים מערכת נכונה, לא רק קוד שעובד</h2>
                        <p className="lead offer-description">
                            אנחנו מתכננים ומפתחים מערכות מותאמות לעסק, מוצרי SaaS ואינטגרציות
                            מורכבות, עם חשיבה על יציבות, צמיחה ותחזוקה נכונה מהיום הראשון.
                        </p>
                        <div className="dev-cta-row">
                            <button
                                type="button"
                                className="btn btn-primary btn-lg cta-btn"
                                onClick={scrollToForm}
                            >
                                השאר פרטים
                            </button>
                            <a
                                href={bookingUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-primary btn-lg cta-btn"
                            >
                                קבעו שיחת ייעוץ
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למי זה מתאים</h3>
                            <div className="bullet-grid">
                                {fitItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">האם זה נשמע מוכר?</h3>
                            <div className="bullet-grid">
                                {problemItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row custom-dev-section align-items-center">
                    <div className="col-md-6">
                        <h3>זה לא רק פיתוח, זה בסיס נכון למערכת של העסק</h3>
                        <p>
                            פיתוח טוב מתחיל בהבנה עסקית, לא רק בטכנולוגיה. המטרה היא לבנות
                            מערכת שתתאים לדרך שבה העסק עובד, ולא עוד פתרון זמני שצריך לתקן אחר כך.
                        </p>
                        <p>
                            אם אתם צריכים מערכת שמותאמת לתהליך העסקי, או אם מה שכבר קיים כבר
                            לא מספיק, זה בדיוק המקום שבו צריך לעצור ולבנות נכון.
                        </p>
                        <div className="signal-list">
                            {audienceSignals.map((item) => (
                                <div key={item} className="signal-item">{item}</div>
                            ))}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img src={a} alt="פיתוח תוכנה בהתאמה לעסק" className="img-fluid" />
                    </div>
                </div>

                <div className="row devops-integration-section align-items-center">
                    <div className="col-md-6">
                        <img src={b} alt="תכנון מערכות ואינטגרציות" className="img-fluid" />
                    </div>
                    <div className="col-md-6">
                        <h3>איך אנחנו עוזרים</h3>
                        <p>
                            אנחנו מפתחים תוכנה בהתאמה אישית, משדרגים ומייצבים מערכות קיימות,
                            בונים מוצרי SaaS ומחברים נכון בין מערכות ותהליכים.
                        </p>
                        <p>
                            העבודה שלנו כוללת גם תכנון מערכת, גם אינטגרציות, וגם חשיבה על
                            פריסה, תחזוקה והמשך פיתוח. לא רק כתיבת קוד, אלא בניית מערכת שאפשר
                            לעבוד איתה לאורך זמן.
                        </p>
                        <div className="signal-list">
                            <div className="signal-item">פיתוח תוכנה בהתאמה אישית</div>
                            <div className="signal-item">שדרוג וייצוב מערכות קיימות</div>
                            <div className="signal-item">פיתוח מוצרי SaaS</div>
                            <div className="signal-item">אינטגרציות בין מערכות</div>
                            <div className="signal-item">שילוב חשיבה תפעולית ו-DevOps</div>
                        </div>
                    </div>
                </div>

                <div className="row saas-products-section align-items-center">
                    <div className="col-md-6">
                        <h3>מה יוצא לכם מזה</h3>
                        <p>
                            מערכת שמתאימה לעסק, בסיס נכון לצמיחה, ופחות טעויות יקרות בהמשך.
                            התוצאה היא פיתוח מסודר יותר, תפעול יעיל יותר ויכולת להמשיך להוסיף בלי לשבור כל פעם משהו.
                        </p>
                        <p>
                            כשהמערכת בנויה נכון, קל יותר לחבר תהליכים, לחסוך עבודה ידנית,
                            לשפר יציבות ולקבל החלטות טובות יותר לגבי ההמשך.
                        </p>
                        <div className="signal-list">
                            <div className="signal-item">שיפור יעילות וחיסכון בזמן</div>
                            <div className="signal-item">מערכת יציבה יותר</div>
                            <div className="signal-item">פחות תלות בפתרונות זמניים</div>
                            <div className="signal-item">יותר ביטחון בהחלטות טכנולוגיות</div>
                            <div className="signal-item">בסיס נכון לצמיחה ולהמשך פיתוח</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img src={c} alt="פיתוח מוצרי SaaS ומערכות עסקיות" className="img-fluid" />
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">איך זה עובד</h3>
                            <div className="process-grid">
                                {processSteps.map((step) => (
                                    <div key={step.number} className="process-card">
                                        <span className="process-number">{step.number}</span>
                                        <h4>{step.title}</h4>
                                        <p>{step.text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למה לעבוד איתנו</h3>
                            <div className="trust-grid">
                                {trustPoints.map((item) => (
                                    <div key={item} className="trust-item">{item}</div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">
                        <div className="final-cta-card">
                            <h3>אם המערכת הנוכחית כבר לא מספיקה, זה הזמן לבנות כיוון נכון</h3>
                            <p className="lead">
                                בואו נבין מה נכון לבנות עכשיו, ומה נכון לתכנן להמשך.
                            </p>
                            <button
                                type="button"
                                className="btn btn-primary btn-lg cta-btn mb-3"
                                onClick={scrollToForm}
                            >
                                השאר פרטים
                            </button>
                            <a
                                href={bookingUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-primary btn-lg cta-btn mb-3"
                            >
                                קבעו שיחת ייעוץ
                            </a>
                            <p className="cta-note mt-3">שיחה ראשונית ללא התחייבות. חזרה תוך 24 שעות.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SoftwareDevelopmentOffer;
